import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import type { PartyDto } from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";
import { formatDate } from "Utils/DateUtils";
import { formatPhone } from "Utils/PhoneUtils";

type Props = {
  partyData: PartyDto;
  title?: string;
};

export const NaturalPersonBasicInfoSection = ({
  title,
  partyData: {
    type,
    addresses,
    phone,
    email,
    personalNumber,
    birthDate,
    birthPlace,
    nationality,
    otherNationalities,
    gender,
    lastName,
    firstName,
  },
}: Props) => {
  const { t } = useResource();
  const { getCountryName, getCountryNames } = useCountryNameResolver();

  // biome-ignore format: item per line
  return (
    <ValuesBox title={title || t(Resources.Common.GeneralInfo)}>
      <ValueItems
        values={[
          { label: t(Resources.Common.PartyTypeLabel), value: t(Resources.Form.PartyType[type]) },
          { label: t(Resources.Common.FirstName), value: firstName || t(Resources.Common.Unknown) },
          { label: t(Resources.Common.LastName), value: lastName || t(Resources.Common.Unknown) },
          { label: t(Resources.Common.Gender), value: t(Resources.Form.PersonalData.Sex[gender])},
          { label: t(Resources.Common.PersonalNumber), value: personalNumber || t(Resources.Common.Unknown) },
          { label: t(Resources.Common.BirthDate), value: birthDate ? formatDate(birthDate) : t(Resources.Common.Unknown) },
          { label: t(Resources.Common.BirthPlace), value: birthPlace || t(Resources.Common.Unknown) },
          { label: t(Resources.Common.Nationality), value: getCountryName(nationality) || t(Resources.Common.Unknown) },
          ...(otherNationalities.length > 0 ? [{ label: t(Resources.Common.OtherNationalities), value: getCountryNames(otherNationalities) }] : []),
          ...addresses.map((address) => ({ label: t(Resources.Form.AddressType[address.type]), value: getFormattedAddress(address) })),
          { label: t(Resources.Common.Phone), value: formatPhone(phone) },
          { label: t(Resources.Common.Email), value: email },
        ]}
      />
    </ValuesBox>
  );
};
